import { render, staticRenderFns } from "./NoServicesAvailable.vue?vue&type=template&id=c2c71edc&scoped=true"
import script from "./NoServicesAvailable.vue?vue&type=script&lang=js"
export * from "./NoServicesAvailable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2c71edc",
  null
  
)

export default component.exports